import React from 'react';

import { cn } from '../../lib/utils';
import { Heading } from '../../shadcn/heading';
import { HeroTitle } from './hero-title';

interface HeroProps {
  pill?: React.ReactNode;
  titleTopImage?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  cta?: React.ReactNode;
  image?: React.ReactNode;
  className?: string;
}

export function Hero({
  pill,
  titleTopImage,
  title,
  subtitle,
  cta,
  image,
  className,
}: HeroProps) {
  return (
    <div className={cn('mx-auto flex flex-col space-y-20', className)}>
      <div
        style={{
          MozAnimationDuration: '100ms',
        }}
        className={cn(
          'mx-auto flex flex-1 flex-col items-center justify-center md:flex-row',
        )}
      >
        <div className="flex w-full flex-1 flex-col items-center space-y-6 xl:space-y-8 2xl:space-y-10">
          {pill && <div>{pill}</div>}

          {titleTopImage && (
            <div className={cn('w-1/2 min-w-60 lg:w-fit')}>{titleTopImage}</div>
          )}

          <div className="flex flex-col items-center space-y-8">
            <HeroTitle>{title}</HeroTitle>

            {subtitle && (
              <div className="flex flex-col space-y-1">
                <Heading
                  level={1}
                  className="p-0 text-center font-sans !text-xl font-medium text-white sm:!text-2xl"
                >
                  {subtitle}
                </Heading>
              </div>
            )}
          </div>

          {cta && <div>{cta}</div>}
        </div>
      </div>

      {image && (
        <div className={cn('mx-auto flex max-w-[85rem] justify-center py-8')}>
          {image}
        </div>
      )}
    </div>
  );
}
